// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* History screens (redesign) — shared by /work-history and
   /customer-history. Both read the same POST /wo/getAllBy/ page of work
   orders and differ only in the columns they draw, so they share one
   vocabulary here rather than carrying two near-identical stylesheets.

   Depends on dashboard-redesign.css for the shell tokens and shared
   .rf-btn / .rf-num / .rf-spacer / .rf-empty / .rf-segmented. */

.hx-page {
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /* .rf-content top-aligns whatever it renders rather than capping its
     height, so bound the page to the viewport minus the 64px top bar and
     the .rf-app gutter + border. The toolbar then stays put and the table
     scrolls inside its card, which is what makes the sticky header work. */
  height: calc(100vh - 76px);
}

/* ---------------- toolbar ---------------- */
.hx-bar {
  background: #fff;
  border-bottom: 1px solid #e2dcd0;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

/* date filter: a native date input in the shell the rest of the app uses,
   with a clear button that only appears once a date is set (the legacy
   picker always showed one, and cleared to "today" rather than to all) */
.hx-date {
  height: 34px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px 0 11px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
}
.hx-date.is-set {
  border-color: #d8c9a4;
  background: #fdfbf6;
}
.hx-date-k {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #a29b8d;
  white-space: nowrap;
}
.hx-date input {
  border: none;
  outline: none;
  background: none;
  font: 500 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  font-variant-numeric: tabular-nums;
  width: 118px;
  padding: 0;
}
.hx-date input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.5;
}
.hx-date input::-webkit-calendar-picker-indicator:hover {
  opacity: 0.9;
}
.hx-date-clear {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border: none;
  border-radius: 6px;
  background: none;
  color: #a29b8d;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.hx-date-clear:hover {
  background: #f4f1ea;
  color: #191714;
}

.hx-search {
  height: 34px;
  min-width: 220px;
  flex-grow: 1;
  max-width: 360px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
}
.hx-search:focus-within {
  border-color: #d8c9a4;
}
.hx-search input {
  border: none;
  outline: none;
  background: none;
  width: 100%;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.hx-search-icon {
  width: 11px;
  height: 11px;
  border: 1.6px solid #a29b8d;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
}
.hx-search-icon::after {
  content: "";
  position: absolute;
  right: -4px;
  bottom: -3px;
  width: 5px;
  height: 1.6px;
  background: #a29b8d;
  transform: rotate(45deg);
}
.hx-count {
  font-size: 12.5px;
  color: #8b8477;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.hx-count b {
  font-weight: 600;
  color: #4a453c;
}

/* ---------------- body ---------------- */
.hx-body {
  flex-grow: 1;
  min-height: 0;
  padding: 18px 28px 26px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
/* the filter summary above the table — says in words what the toolbar is
   doing, so an empty result is explainable rather than just empty */
.hx-lede {
  flex-shrink: 0;
  font-size: 12.5px;
  color: #8b8477;
  line-height: 1.5;
  margin: 0;
}
.hx-lede b {
  font-weight: 600;
  color: #4a453c;
}

.hx-tablewrap {
  flex-grow: 1;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.hx-scroll {
  flex-grow: 1;
  overflow: auto;
  min-height: 0;
}
.hx-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}
.hx-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #474339;
  color: #f2efe8;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  text-align: left;
  padding: 9px 12px;
  white-space: nowrap;
  border: none;
}
.hx-table thead th.is-center {
  text-align: center;
}
.hx-table tbody td {
  padding: 10px 12px;
  border-bottom: 1px solid #f0ece3;
  vertical-align: top;
  color: #4a453c;
  line-height: 1.45;
}
.hx-table tbody tr:last-child td {
  border-bottom: none;
}
.hx-row:hover > td {
  background: #fdfbf6;
}

/* Rows arrive newest-first by entry timestamp; a day heading turns that
   ordering into something you can read. The legacy pages rendered a
   TableRowSeparator that never received a date and so never appeared. */
.hx-grouprow > td {
  padding: 0;
  border-bottom: 1px solid #f0ece3;
  background: #faf8f3;
}
.hx-group {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 7px 12px;
}
.hx-group-d {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--rf-brand);
  white-space: nowrap;
}
.hx-group-n {
  font-size: 11px;
  color: #bdb6a7;
  font-variant-numeric: tabular-nums;
}

.hx-num {
  width: 44px;
  color: #bdb6a7;
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
}
.hx-lead {
  min-width: 170px;
}
.hx-lead-name {
  display: block;
  font-weight: 600;
  color: #191714;
  overflow-wrap: anywhere;
}
.hx-lead-sub {
  display: block;
  font-size: 11px;
  color: #a29b8d;
  margin-top: 1px;
  overflow-wrap: anywhere;
}
.hx-plain {
  min-width: 130px;
  overflow-wrap: anywhere;
}
.hx-empty-v {
  color: #c4bdad;
}
.hx-date-v {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.hx-date-v span {
  display: block;
  font-size: 11px;
  color: #bdb6a7;
  margin-top: 1px;
}

/* contact column: the number and the address are the point of a customer
   record, so they are links you can act on rather than flat text */
.hx-contact {
  min-width: 150px;
}
.hx-contact a {
  display: block;
  color: var(--rf-brand);
  overflow-wrap: anywhere;
}
.hx-contact a:hover {
  color: var(--rf-brand-hover);
  text-decoration: underline;
}
.hx-contact .hx-empty-v {
  display: block;
}

/* Products used to be one comma-run of "2 x Casket cover, 1 x Wreath"
   squeezed into 30% of the row. One chip per line item reads at a glance
   and wraps instead of truncating. */
.hx-prods {
  min-width: 230px;
}
.hx-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.hx-chip {
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--rf-brand-tint);
  border: 1px solid var(--rf-brand-edge);
  font-size: 11px;
  color: var(--rf-brand-deep);
  max-width: 100%;
  overflow-wrap: anywhere;
}
.hx-chip b {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.hx-chip.is-cc {
  background: #eef2f1;
  border-color: #d5e0de;
  color: #33564f;
}

.hx-type {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  background: #f4f1ea;
  border: 1px solid #e7e3da;
  color: #8b8477;
}

/* ---------------- footer / pagination ---------------- */
.hx-foot {
  border-top: 1px solid #f0ece3;
  background: #fdfcfa;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.hx-foot-note {
  font-size: 11.5px;
  color: #a29b8d;
  font-variant-numeric: tabular-nums;
}
.hx-pager {
  display: flex;
  align-items: center;
  gap: 5px;
}
.hx-pager button {
  min-width: 30px;
  height: 30px;
  padding: 0 9px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
  color: #4a453c;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  cursor: pointer;
  font-variant-numeric: tabular-nums;
}
.hx-pager button:hover:not(:disabled) {
  background: #f6f4ef;
}
.hx-pager button.is-active {
  background: var(--rf-brand);
  border-color: var(--rf-brand);
  color: #fff;
}
.hx-pager button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.hx-gap {
  font-size: 12px;
  color: #c4bdad;
  padding: 0 2px;
}

/* ---------------- states ---------------- */
.hx-state {
  padding: 40px 20px;
  text-align: center;
  font-size: 13px;
  color: #8b8477;
  line-height: 1.6;
}
.hx-state b {
  display: block;
  font-size: 14.5px;
  font-weight: 600;
  color: #4a453c;
  margin-bottom: 3px;
}
.hx-state .rf-btn {
  margin-top: 12px;
}
.hx-skel {
  height: 13px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f2efe8 25%, #f8f6f1 50%, #f2efe8 75%);
  background-size: 300% 100%;
  animation: hx-shimmer 1.3s linear infinite;
}
@keyframes hx-shimmer {
  from {
    background-position: 150% 0;
  }
  to {
    background-position: -150% 0;
  }
}

@media (max-width: 860px) {
  .hx-bar,
  .hx-body {
    padding-left: 16px;
    padding-right: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/history.css"],"names":[],"mappings":"AAAA;;;;;;gEAMgE;;AAEhE;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB;;;2EAGyE;EACzE,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;;yEAEyE;AACzE;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gEAAgE;EAChE,cAAc;EACd,kCAAkC;EAClC,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;oEACoE;AACpE;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;;wEAEwE;AACxE;EACE,UAAU;EACV,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;mEACmE;AACnE;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,sCAAsC;EACtC,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,8DAA8D;EAC9D,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,0CAA0C;AAC5C;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":["/* History screens (redesign) — shared by /work-history and\n   /customer-history. Both read the same POST /wo/getAllBy/ page of work\n   orders and differ only in the columns they draw, so they share one\n   vocabulary here rather than carrying two near-identical stylesheets.\n\n   Depends on dashboard-redesign.css for the shell tokens and shared\n   .rf-btn / .rf-num / .rf-spacer / .rf-empty / .rf-segmented. */\n\n.hx-page {\n  flex-grow: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  /* .rf-content top-aligns whatever it renders rather than capping its\n     height, so bound the page to the viewport minus the 64px top bar and\n     the .rf-app gutter + border. The toolbar then stays put and the table\n     scrolls inside its card, which is what makes the sticky header work. */\n  height: calc(100vh - 76px);\n}\n\n/* ---------------- toolbar ---------------- */\n.hx-bar {\n  background: #fff;\n  border-bottom: 1px solid #e2dcd0;\n  padding: 12px 28px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n/* date filter: a native date input in the shell the rest of the app uses,\n   with a clear button that only appears once a date is set (the legacy\n   picker always showed one, and cleared to \"today\" rather than to all) */\n.hx-date {\n  height: 34px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 4px 0 11px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n}\n.hx-date.is-set {\n  border-color: #d8c9a4;\n  background: #fdfbf6;\n}\n.hx-date-k {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  white-space: nowrap;\n}\n.hx-date input {\n  border: none;\n  outline: none;\n  background: none;\n  font: 500 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n  width: 118px;\n  padding: 0;\n}\n.hx-date input::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  opacity: 0.5;\n}\n.hx-date input::-webkit-calendar-picker-indicator:hover {\n  opacity: 0.9;\n}\n.hx-date-clear {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  border: none;\n  border-radius: 6px;\n  background: none;\n  color: #a29b8d;\n  font-size: 15px;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.hx-date-clear:hover {\n  background: #f4f1ea;\n  color: #191714;\n}\n\n.hx-search {\n  height: 34px;\n  min-width: 220px;\n  flex-grow: 1;\n  max-width: 360px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n}\n.hx-search:focus-within {\n  border-color: #d8c9a4;\n}\n.hx-search input {\n  border: none;\n  outline: none;\n  background: none;\n  width: 100%;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.hx-search-icon {\n  width: 11px;\n  height: 11px;\n  border: 1.6px solid #a29b8d;\n  border-radius: 50%;\n  position: relative;\n  flex-shrink: 0;\n}\n.hx-search-icon::after {\n  content: \"\";\n  position: absolute;\n  right: -4px;\n  bottom: -3px;\n  width: 5px;\n  height: 1.6px;\n  background: #a29b8d;\n  transform: rotate(45deg);\n}\n.hx-count {\n  font-size: 12.5px;\n  color: #8b8477;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.hx-count b {\n  font-weight: 600;\n  color: #4a453c;\n}\n\n/* ---------------- body ---------------- */\n.hx-body {\n  flex-grow: 1;\n  min-height: 0;\n  padding: 18px 28px 26px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n/* the filter summary above the table — says in words what the toolbar is\n   doing, so an empty result is explainable rather than just empty */\n.hx-lede {\n  flex-shrink: 0;\n  font-size: 12.5px;\n  color: #8b8477;\n  line-height: 1.5;\n  margin: 0;\n}\n.hx-lede b {\n  font-weight: 600;\n  color: #4a453c;\n}\n\n.hx-tablewrap {\n  flex-grow: 1;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 14px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n.hx-scroll {\n  flex-grow: 1;\n  overflow: auto;\n  min-height: 0;\n}\n.hx-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12.5px;\n}\n.hx-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #474339;\n  color: #f2efe8;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  text-align: left;\n  padding: 9px 12px;\n  white-space: nowrap;\n  border: none;\n}\n.hx-table thead th.is-center {\n  text-align: center;\n}\n.hx-table tbody td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f0ece3;\n  vertical-align: top;\n  color: #4a453c;\n  line-height: 1.45;\n}\n.hx-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.hx-row:hover > td {\n  background: #fdfbf6;\n}\n\n/* Rows arrive newest-first by entry timestamp; a day heading turns that\n   ordering into something you can read. The legacy pages rendered a\n   TableRowSeparator that never received a date and so never appeared. */\n.hx-grouprow > td {\n  padding: 0;\n  border-bottom: 1px solid #f0ece3;\n  background: #faf8f3;\n}\n.hx-group {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  padding: 7px 12px;\n}\n.hx-group-d {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n  white-space: nowrap;\n}\n.hx-group-n {\n  font-size: 11px;\n  color: #bdb6a7;\n  font-variant-numeric: tabular-nums;\n}\n\n.hx-num {\n  width: 44px;\n  color: #bdb6a7;\n  font-size: 11.5px;\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n  white-space: nowrap;\n}\n.hx-lead {\n  min-width: 170px;\n}\n.hx-lead-name {\n  display: block;\n  font-weight: 600;\n  color: #191714;\n  overflow-wrap: anywhere;\n}\n.hx-lead-sub {\n  display: block;\n  font-size: 11px;\n  color: #a29b8d;\n  margin-top: 1px;\n  overflow-wrap: anywhere;\n}\n.hx-plain {\n  min-width: 130px;\n  overflow-wrap: anywhere;\n}\n.hx-empty-v {\n  color: #c4bdad;\n}\n.hx-date-v {\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n.hx-date-v span {\n  display: block;\n  font-size: 11px;\n  color: #bdb6a7;\n  margin-top: 1px;\n}\n\n/* contact column: the number and the address are the point of a customer\n   record, so they are links you can act on rather than flat text */\n.hx-contact {\n  min-width: 150px;\n}\n.hx-contact a {\n  display: block;\n  color: var(--rf-brand);\n  overflow-wrap: anywhere;\n}\n.hx-contact a:hover {\n  color: var(--rf-brand-hover);\n  text-decoration: underline;\n}\n.hx-contact .hx-empty-v {\n  display: block;\n}\n\n/* Products used to be one comma-run of \"2 x Casket cover, 1 x Wreath\"\n   squeezed into 30% of the row. One chip per line item reads at a glance\n   and wraps instead of truncating. */\n.hx-prods {\n  min-width: 230px;\n}\n.hx-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n.hx-chip {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 5px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--rf-brand-tint);\n  border: 1px solid var(--rf-brand-edge);\n  font-size: 11px;\n  color: var(--rf-brand-deep);\n  max-width: 100%;\n  overflow-wrap: anywhere;\n}\n.hx-chip b {\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n.hx-chip.is-cc {\n  background: #eef2f1;\n  border-color: #d5e0de;\n  color: #33564f;\n}\n\n.hx-type {\n  display: inline-block;\n  padding: 1px 7px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  background: #f4f1ea;\n  border: 1px solid #e7e3da;\n  color: #8b8477;\n}\n\n/* ---------------- footer / pagination ---------------- */\n.hx-foot {\n  border-top: 1px solid #f0ece3;\n  background: #fdfcfa;\n  padding: 9px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n.hx-foot-note {\n  font-size: 11.5px;\n  color: #a29b8d;\n  font-variant-numeric: tabular-nums;\n}\n.hx-pager {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.hx-pager button {\n  min-width: 30px;\n  height: 30px;\n  padding: 0 9px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n  color: #4a453c;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  cursor: pointer;\n  font-variant-numeric: tabular-nums;\n}\n.hx-pager button:hover:not(:disabled) {\n  background: #f6f4ef;\n}\n.hx-pager button.is-active {\n  background: var(--rf-brand);\n  border-color: var(--rf-brand);\n  color: #fff;\n}\n.hx-pager button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.hx-gap {\n  font-size: 12px;\n  color: #c4bdad;\n  padding: 0 2px;\n}\n\n/* ---------------- states ---------------- */\n.hx-state {\n  padding: 40px 20px;\n  text-align: center;\n  font-size: 13px;\n  color: #8b8477;\n  line-height: 1.6;\n}\n.hx-state b {\n  display: block;\n  font-size: 14.5px;\n  font-weight: 600;\n  color: #4a453c;\n  margin-bottom: 3px;\n}\n.hx-state .rf-btn {\n  margin-top: 12px;\n}\n.hx-skel {\n  height: 13px;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #f2efe8 25%, #f8f6f1 50%, #f2efe8 75%);\n  background-size: 300% 100%;\n  animation: hx-shimmer 1.3s linear infinite;\n}\n@keyframes hx-shimmer {\n  from {\n    background-position: 150% 0;\n  }\n  to {\n    background-position: -150% 0;\n  }\n}\n\n@media (max-width: 860px) {\n  .hx-bar,\n  .hx-body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
